/** AG Grid 32.2+ multi-row selection (replaces deprecated rowSelection "multiple"). */
export const multiRowSelection = {
  mode: 'multiRow',
  headerCheckbox: false,
  checkboxes: false,
};
